import React from "react";
import { Link } from "react-router-dom";
import MatchSummaryWide from "./MatchSummaryWide";
import PoolInformation from "./PoolInformation";
import { getPrettyDate } from "../lib/format";

// BET NOW while the pool is open, VIEW LIVE once it has closed, otherwise nothing.
const statusButton = (item) => {
  if (item.poolStatus === "OPEN") {
    return (
      <a
        href={"https://www.tab.co.za/tabs/soccer/" + item.programDate + "/" + item.programCode + "/" + item.race}
        className="button button4R tiny right betnowbutton"
        rel="noopener noreferrer"
      >
        BET NOW
      </a>
    );
  }
  if (item.poolStatus === "CLOSED") {
    return (
      <Link
        to={"/live-pool-projections#" + item.programDate + "_" + item.programCode + "_" + item.race}
        style={{ backgroundColor: "#e8004c" }}
        className="button tiny right"
      >
        VIEW LIVE
      </Link>
    );
  }
  return "";
};

const PoolItemWide = ({ item }) => {
  return (
    <div>
      <div className="pooldateindicator4R">
        {getPrettyDate(item.programDate)} - {item.PartitionKey.replaceAll("S11 ", "Mega 10 ")}
        <Link
          to={"/form-guides/previews-by-pool#" + item.programDate + "_" + item.programCode + "_" + item.race}
          style={{ float: "right", margin: "2px", fontSize: "0.85em", color: "#fafafa" }}
        >
          Read Pool Preview
        </Link>
      </div>
      <table className="pooltable">
        <tbody>
          <tr>
            <th>Match</th>
            <th>Team A</th>
            <th className="centertext">v</th>
            <th className="righttext">Team B</th>
          </tr>
          {JSON.parse(item.matches).map((match) => (
            <MatchSummaryWide item={match} pool_title={item.PartitionKey} />
          ))}
        </tbody>
      </table>
      <PoolInformation item={item} statusButton={statusButton(item)} />
    </div>
  );
};

export default PoolItemWide;
